// @ts-nocheck
import {
  DeleteOutlined,
  FormOutlined,
  MoreOutlined,
  PrinterOutlined,
} from '@ant-design/icons'
import {
  Col,
  Dropdown,
  List,
  Menu,
  Modal,
  Progress,
  Row,
  Tag,
  Tooltip,
  message,
} from 'antd'
import { inject, observer } from 'mobx-react'
import React, { Fragment, useEffect, useMemo, useState } from 'react'
import { Helmet } from 'react-helmet'
import { blue } from '../../../color'
import AccessControlAction from '../../../components/AccessControlAction'
import { EmptyText, TitleContentBox } from '../../../components/Common/CellText'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import FeedbackSign from '../../../components/PopupSign/FeedbackSign'
import { systemName } from '../../../config'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  VIEWLOG_DATE,
} from '../../../constants'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { FeedbackProcedureRequest } from '../../../requests/FeedbackProcedureRequest'
import utils from '../../../utils'
import {
  DocumentInfoList,
  UserListWrapper,
} from '../InternalDocumentIncomingDocDetailPage/InternalDocumentIncomingDocDetailPageStyled'
import ExportDocx from './ExportWord/ExportWord'
import {
  BlockLeft,
  BlockRight,
  ContentWrapper,
  HeadingButtonWrapper,
  ViewDetailContent,
} from './FeedbackBoardPageStyled'
import FeedbackBoardUpdate from './FeedbackBoardUpdate '
import FeedbackCommentSection from './FeedbackCommentSection'
import FeedbackVotingPopup from './FeedbackVote/FeedbackVotingPopup'
import PopoverWatchTime from './components/PopoverWatchTime'

const FeedbackBoardDetail = props => {
  const {
    selectPeopleStore,
    fileStore,
    userGroupStore,
    signedDocumentStore,
    authenticationStore,
    loadingAnimationStore,
    FeedbackProcedureStore,
    FeedbackCommentStore,
    departmentStore,
    selectUserStore,
    userStore,
    match,
    history,
    location,
  } = props

  const { departmentWithUserListV2 } = selectPeopleStore
  const { userList } = userStore
  const { feedbackId } = match.params
  const { currentUser } = authenticationStore
  const { feedbackDetailData } = FeedbackProcedureStore
  const { documentAttachment } = fileStore
  const { allDataGroupList } = userGroupStore
  const { feedbackCommentDataDetailV2 } = FeedbackCommentStore
  const [isVisiblePopupBieuQuyet, setIsVisiblePopupBieuQuyet] = useState(false)
  const [asigneeData, setAsigneeData] = useState([])
  const [isEditModalVisible, setIsEditModalVisible] = useState(false)
  const [exportDocx, setExportDocx] = useState(false)
  const [isMenuOpen, setIsMenuOpen] = useState(true)
  const [selectedIndex, setSelectedIndex] = useState(null)
  const [indexLmao, setIndexLmao] = useState(null)
  const [isVisiblePopupSign, setIsVisiblePopupSign] = useState(false)

  const fetchDetailComment = async id => {
    try {
      await FeedbackCommentStore.getFeedbackCommentById(id)
    } catch (error) {
      loadingAnimationStore.showSpinner(false)
    }
  }

  useEffect(() => {
    ;(async () => {
      try {
        await selectPeopleStore.getGroupList()
        await selectPeopleStore.getDepartmentWithUsersV2()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        loadingAnimationStore.showSpinner(false)
      }
    })()
  }, [])

  feedbackDetailData?.assignees?.forEach(assignee => {
    const matchingData = departmentWithUserListV2?.find(
      item => item.code === assignee.assignee_code
    )
    if (matchingData) {
      assignee.length = matchingData.length
    }
  })
  const departmentMap = useMemo(() => {
    const map = new Map()
    departmentWithUserListV2?.forEach(dept => {
      map.set(dept.code, dept.name)
      dept.users.forEach(user => {
        map.set(user.user_code, user.name_uppercase)
      })
    })
    return map
  }, [departmentWithUserListV2])

  useEffect(() => {
    if (!feedbackDetailData?.assignees || !departmentMap.size) return

    const assigneesProcessed = feedbackDetailData.assignees.map(assignee => {
      assignee.name_uppercase =
        departmentMap.get(assignee.assignee_code) || assignee.name_uppercase
      return assignee
    })

    setAsigneeData(assigneesProcessed)
    loadingAnimationStore.showSpinner(false)
  }, [departmentMap, feedbackDetailData?.assignees])
  const handleOpenPopup = () => {
    setIsVisiblePopupBieuQuyet(true)
  }

  const handleClosePopup = () => {
    setIsVisiblePopupBieuQuyet(false)
  }

  const handleOpenEditModal = () => {
    console.log('Opening edit modal')
    setIsEditModalVisible(true)
  }

  const handleCloseEditModal = () => {
    console.log('Closing edit modal')
    setIsEditModalVisible(false)
  }

  const handleExportDocx = shouldExport => {
    if (shouldExport) {
      setExportDocx(true)
    }
  }

  useEffect(() => {
    if (exportDocx) {
      setExportDocx(false)
    }
  }, [exportDocx])

  const fetchFeedbackDetailData = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await FeedbackProcedureStore.getElectronicDocumentById(feedbackId)
    } catch (err) {
      console.log(err)
    }

    loadingAnimationStore.showSpinner(false)
  }

  useEffect(() => {
    fetchFeedbackDetailData()
  }, [feedbackId])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      loadingAnimationStore.showSpinner(true)
      userStore.setFilter('userListStatus', true)
      userStore.setFilter(
        'companyCode',
        authenticationStore.currentCompanyCode()
      )
      userStore.getUserListV2().finally(() => {
        loadingAnimationStore.showSpinner(false)
      })
    }
    return () => {
      userStore.clearStore()
    }
  }, [authenticationStore.currentUser])

  const groupType = location.pathname.includes('feedback-hdqt')
    ? 'nhiem_vu'
    : undefined

  useEffect(() => {
    ;(async () => {
      if (authenticationStore.currentUser) {
        try {
          loadingAnimationStore.showSpinner(true)
          const responseGroupList = await userGroupStore.getAllGroupList()
        } catch (err) {
          console.log(err)
          message.error('Đã có lỗi xảy ra!')
        } finally {
          loadingAnimationStore.showSpinner(false)
        }
      }
    })()
  }, [authenticationStore.currentUser])

  function getNameUppercaseByUsername(username) {
    const user = userList?.find(user => user.username === username)
    if (user) {
      return user.name_uppercase
    } else {
      return `Admin`
    }
  }

  const [allFileNames, setAllFileNames] = useState([])
  useEffect(() => {
    const fetchFileNames = async () => {
      if (!feedbackDetailData?.fileIdAttachment) return
      const allFileNamesResponse = await Promise.all(
        feedbackDetailData.fileIdAttachment.map(fileId =>
          FeedbackProcedureStore.getElectronicDocumentFileName(
            fileId.fileId.replace(/[\[\]]/g, '')
          )
        )
      )
      setAllFileNames(allFileNamesResponse.map(response => response.data))
    }
    fetchFileNames()
  }, [feedbackDetailData?.fileIdAttachment])

  const idIncludes = feedbackDetailData?.feedbackComments?.map(item => item.id)
  const feedbackComments = feedbackCommentDataDetailV2?.feedbackCommentDetails

  const latestFeedbacks =
    feedbackCommentDataDetailV2?.feedbackCommentDetails &&
    Array.from(
      feedbackCommentDataDetailV2.feedbackCommentDetails
        .filter(detail => !detail?.isDeleted)
        .reduce((map, comment) => {
          if (comment.fileId) {
            const existing = map.get(comment.feedbackUsername)
            if (
              !existing ||
              new Date(comment.createdAt) > new Date(existing.createdAt)
            ) {
              map.set(comment.feedbackUsername, comment)
            }
          }
          return map
        }, new Map())
        .values()
    )

  const results = feedbackDetailData?.feedbackComments?.map(comment => {
    const latestVotes = {}
    comment.feedbackCommentDetails.forEach(detail => {
      const { feedbackUsername, voteType, createdAt } = detail
      if (voteType) {
        if (
          !latestVotes[feedbackUsername] ||
          new Date(latestVotes[feedbackUsername].createdAt) <
            new Date(createdAt)
        ) {
          latestVotes[feedbackUsername] = {
            ...detail,
            content: comment.content,
          }
        }
      }
    })
    return Object.values(latestVotes)
  })
  const voteCounts = {
    AGREE: 0,
    DISAGREE: 0,
    OTHER: 0,
  }

  let totalCount = 0

  results?.forEach(feedbackGroup => {
    feedbackGroup.forEach(feedback => {
      if (feedback.voteType in voteCounts) {
        voteCounts[feedback.voteType]++
      }
      totalCount++
    })
  })

  const countAllUser = latestFeedbacks?.length || 0
  const countAgree =
    latestFeedbacks?.filter(comment => comment.voteType === 'AGREE')?.length ||
    0

  const countDisAgree =
    latestFeedbacks?.filter(comment => comment.voteType === 'DISAGREE')
      ?.length || 0

  const countOther =
    latestFeedbacks?.filter(comment => comment.voteType === 'OTHER')?.length ||
    0
  let agreeCount = 0
  let disagreeCount = 0
  let otherCount = 0
  latestFeedbacks?.forEach(comment => {
    comment?.feedbackCommentDetails?.forEach(detail => {
      if (detail.voteType === 'AGREE') {
        agreeCount++
      } else if (detail.voteType === 'DISAGREE') {
        disagreeCount++
      } else if (detail.voteType === 'OTHER') {
        otherCount++
      }
    })
  })
  let totalVote = agreeCount + disagreeCount + otherCount

  const picAssignees =
    feedbackDetailData?.assignees?.filter(
      assignee => assignee.permission === 'PIC'
    ) || []

  const uniqueAssignees = []
  const seenCodes = new Set()

  for (const assignee of picAssignees) {
    if (!seenCodes.has(assignee.assignee_code)) {
      uniqueAssignees.push(assignee)
      seenCodes.add(assignee.assignee_code)
    } else {
      const existingIndex = uniqueAssignees.findIndex(
        a => a.assignee_code === assignee.assignee_code
      )
      if (
        existingIndex !== -1 &&
        uniqueAssignees[existingIndex].assignee_type === 'USER' &&
        assignee.assignee_type === 'DPT'
      ) {
        uniqueAssignees[existingIndex] = assignee
      }
    }
  }

  const totalPeopleCount = uniqueAssignees.reduce(
    (sum, assignee) => sum + (assignee.length || 0),
    0
  )

  const collectPicUsernames = assignees => {
    const canonicalSet = new Set()
    const knownIds = new Map()

    const addPerson = (...ids) => {
      const validIds = [
        ...new Set(
          ids.filter(Boolean).map(id => String(id).trim().toLowerCase())
        ),
      ]
      if (!validIds.length) return

      const existingCanonical = validIds
        .map(id => knownIds.get(id))
        .find(Boolean)
      const canonical = existingCanonical || validIds[0]

      if (!existingCanonical) {
        canonicalSet.add(canonical)
      }
      validIds.forEach(id => knownIds.set(id, canonical))
    }

    const findUserAliases = assigneeCode => {
      let userName = assigneeCode
      let userCode
      departmentWithUserListV2?.forEach(dept => {
        const matched = dept.users?.find(
          user =>
            user.user_name === assigneeCode ||
            user.user_code === assigneeCode ||
            user.username === assigneeCode
        )
        if (matched) {
          userName = matched.user_name || matched.username || assigneeCode
          userCode = matched.user_code
        }
      })
      return [userName, userCode, assigneeCode]
    }

    const uniquePicAssignees = []
    const seenAssigneeCodes = new Set()
    assignees?.forEach(assignee => {
      const code = assignee.assignee_code?.toString()
      if (!code || seenAssigneeCodes.has(code)) return
      seenAssigneeCodes.add(code)
      uniquePicAssignees.push(assignee)
    })

    uniquePicAssignees.forEach(assignee => {
      if (assignee.assignee_type === ASSIGNEE_TYPE.USER) {
        addPerson(...findUserAliases(assignee.assignee_code))
        return
      }

      if (assignee.assignee_type === ASSIGNEE_TYPE.DEPARTMENT) {
        const department = departmentWithUserListV2?.find(
          dept => dept.code === assignee.assignee_code
        )
        department?.users?.forEach(user => {
          const primary = user.user_name || user.username || user.user_code
          addPerson(
            ...findUserAliases(primary),
            user.user_name,
            user.username,
            user.user_code
          )
        })
        return
      }

      if (assignee.assignee_type === ASSIGNEE_TYPE.GROUP) {
        const matchedGroup = allDataGroupList?.find(
          group => group.id?.toString() === assignee.assignee_code?.toString()
        )
        matchedGroup?.groupUsers?.forEach(groupUser => {
          const user = groupUser?.user || groupUser
          // Bỏ user inactive trong nhóm (status === false)
          if ((user?.status ?? groupUser?.status) === false) return

          const primary =
            user?.user_name ||
            user?.username ||
            user?.user_code ||
            groupUser?.user_name
          addPerson(
            ...findUserAliases(primary),
            user?.user_name,
            user?.username,
            user?.user_code,
            groupUser?.user_name
          )
        })
      }
    })

    return canonicalSet
  }

  const totalPeopleCountv2 = collectPicUsernames(picAssignees).size

  const handleDelete = () => {
    Modal.confirm({
      title: 'Bạn có muốn xóa ý kiến này không?',
      okText: 'Đồng ý',
      okType: 'danger',
      cancelText: 'Hủy',
      onOk: async () => {
        try {
          await FeedbackProcedureRequest.deleteFeedbackProcedure(
            feedbackDetailData.id
          )
          message.success('Đã xóa ý kiến thành công!')
          history.push('/feedback-hdqt')
        } catch (error) {
          // console.log('Error when delete feedback procedure', error)
        }
      },
      onCancel() {
        console.log('Cancelled deletion')
      },
    })
  }

  feedbackDetailData?.assignees?.forEach(el => {
    if (el.assignee_type === ASSIGNEE_TYPE.USER) {
      const user =
        userList && userList?.find(user => user.username === el.assignee_code)
      if (user) {
        el.name_uppercase = user.name_uppercase
      }
    }
    if (el.assignee_type === ASSIGNEE_TYPE.GROUP) {
      const matchedGroup = allDataGroupList?.find(
        group => group.id.toString() === el.assignee_code
      )
      if (matchedGroup) {
        el.name_uppercase = matchedGroup.name?.toUpperCase()
      }
    }
  })

  const handlerAssignList =
    feedbackDetailData?.assignees
      ?.filter(el => el.permission === 'PIC')
      ?.reduce((unique, item) => {
        const isDuplicate = unique.some(
          el => el.assignee_code === item.assignee_code
        )
        return isDuplicate ? unique : [...unique, item]
      }, []) || []

  const combinerAssignList =
    feedbackDetailData?.assignees
      ?.filter(el => el.permission === 'VIEW')
      ?.reduce((unique, item) => {
        const isDuplicate = unique.some(
          el => el.assignee_code === item.assignee_code
        )
        return isDuplicate ? unique : [...unique, item]
      }, []) || []

  const enrichAssignee = assignee => {
    let name_uppercase = assignee.name_uppercase
    let username = assignee.username
    let image = assignee.image

    if (!name_uppercase) {
      if (assignee.assignee_type === ASSIGNEE_TYPE.USER) {
        const matchedUser = userList?.find(
          user => user.username === assignee.assignee_code
        )
        if (matchedUser) {
          name_uppercase = matchedUser.name_uppercase
          username = matchedUser.username
          image = matchedUser.image
        }
      } else if (assignee.assignee_type === ASSIGNEE_TYPE.GROUP) {
        const matchedGroup = allDataGroupList?.find(
          group => group.id.toString() === assignee.assignee_code
        )
        if (matchedGroup) {
          name_uppercase = matchedGroup.name?.toUpperCase() || null
          image = matchedGroup.image || null
        }
      } else if (assignee.assignee_type === ASSIGNEE_TYPE.DEPARTMENT) {
        name_uppercase =
          departmentMap.get(assignee.assignee_code) || assignee.name_uppercase
      }
    }

    return {
      ...assignee,
      name_uppercase,
      username,
      image,
    }
  }

  const handlerAssignListWithNames = handlerAssignList.map(enrichAssignee)
  const combinerAssignListWithNames = combinerAssignList.map(enrichAssignee)

  const isVotingUser = feedbackDetailData?.assignees?.filter(
    el => el.permission === 'PIC'
  )
  const isUnVotingUser = feedbackDetailData?.assignees?.filter(
    el => el.permission === 'VIEW'
  )

  const uniqueUsers = Array.from(collectPicUsernames(isVotingUser)).map(
    username => ({
      user_name: username,
    })
  )
  const uniqueUsersv2 = Array.from(collectPicUsernames(isUnVotingUser)).map(
    username => ({
      user_name: username,
    })
  )

  const userNameHaveVoting = uniqueUsersv2.map(user => user.user_name)
  const userNameHaventVoting = uniqueUsers.map(user => user.user_name)

  const menuHandleDocument = (
    <Menu>
      <AccessControlAction aclActionType={ACL_ACTION_TYPE.update__HDQT}>
        <Menu.Item
          icon={<FormOutlined style={{ color: blue }} />}
          onClick={handleOpenEditModal}>
          <span style={{ color: blue }}>Chỉnh sửa</span>
        </Menu.Item>
      </AccessControlAction>

      <AccessControlAction aclActionType={ACL_ACTION_TYPE.export__HDQT}>
        <Menu.Item
          icon={<PrinterOutlined style={{ color: blue }} />}
          onClick={() => {
            handleExportDocx(true)
          }}>
          <span style={{ color: blue }}>In</span>
        </Menu.Item>
      </AccessControlAction>

      <AccessControlAction aclActionType={ACL_ACTION_TYPE.delete__HDQT}>
        <Menu.Item danger onClick={handleDelete} icon={<DeleteOutlined />}>
          Xóa phiếu
        </Menu.Item>
      </AccessControlAction>
    </Menu>
  )

  const getVoteCountsForFeedback = feedbackId => {
    const selectedFeedback = feedbackDetailData?.feedbackComments?.find(
      comment => comment.id === feedbackId
    )

    const voteCounts = { AGREE: 0, DISAGREE: 0, OTHER: 0 }
    let totalCount = 0

    if (selectedFeedback) {
      const latestVotes = selectedFeedback.feedbackCommentDetails.reduce(
        (acc, detail) => {
          const { feedbackUsername, voteType, createdAt } = detail
          if (voteType) {
            if (
              !acc[feedbackUsername] ||
              new Date(acc[feedbackUsername].createdAt) < new Date(createdAt)
            ) {
              acc[feedbackUsername] = detail
            }
          }
          return acc
        },
        {}
      )

      Object.values(latestVotes).forEach(detail => {
        if (detail.voteType in voteCounts) {
          voteCounts[detail.voteType]++
          totalCount++
        }
      })
    }

    return { voteCounts, totalCount }
  }

  const getDataForFeedback = feedbackId => {
    const { voteCounts } = getVoteCountsForFeedback(feedbackId)
    if (selectedIndex && feedbackId === selectedIndex) {
      return [
        {
          label: 'Tán thành',
          countValue:
            voteCounts.AGREE === 0
              ? `0/${totalPeopleCountv2}`
              : `${voteCounts.AGREE}/${totalPeopleCountv2}`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.AGREE / totalPeopleCountv2) * 100,
          color: 'blue',
        },
        {
          label: 'Không tán thành',
          countValue:
            voteCounts.DISAGREE === 0
              ? `0/${totalPeopleCountv2}`
              : `${voteCounts.DISAGREE}/${totalPeopleCountv2}`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.DISAGREE / totalPeopleCountv2) * 100,
          color: 'red',
        },
        {
          label: 'Không có ý kiến',
          countValue:
            voteCounts.OTHER === 0
              ? `0/${totalPeopleCountv2}`
              : `${voteCounts.OTHER}/${totalPeopleCountv2}`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.OTHER / totalPeopleCountv2) * 100,
          color: 'green',
        },
      ]
    } else {
      return [
        {
          label: 'Tán thành',
          value:
            totalPeopleCountv2 === 0
              ? '0%'
              : `${((voteCounts.AGREE / totalPeopleCountv2) * 100).toFixed(
                  2
                )}%`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.AGREE / totalPeopleCountv2) * 100,
          color: 'blue',
        },
        {
          label: 'Không tán thành',
          value:
            totalPeopleCountv2 === 0
              ? '0%'
              : `${((voteCounts.DISAGREE / totalPeopleCountv2) * 100).toFixed(
                  2
                )}%`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.DISAGREE / totalPeopleCountv2) * 100,
          color: 'red',
        },
        {
          label: 'Không có ý kiến',
          value:
            totalPeopleCountv2 === 0
              ? '0%'
              : `${((voteCounts.OTHER / totalPeopleCountv2) * 100).toFixed(
                  2
                )}%`,
          percent:
            totalPeopleCountv2 === 0
              ? 0
              : (voteCounts.OTHER / totalPeopleCountv2) * 100,
          color: 'green',
        },
      ]
    }
  }

  console.log(JSON.stringify(getDataForFeedback(1)))

  const data = [
    {
      label: 'Tán thành',
      value: `${Number(countAgree)}/${Number(totalPeopleCountv2)}`,
      percent: (Number(countAgree) / Number(totalPeopleCountv2)) * 100,
      color: 'blue',
    },
    {
      label: 'Không tán thành',
      value: `${Number(countDisAgree)}/${Number(totalPeopleCountv2)}`,
      percent: (Number(countDisAgree) / Number(totalPeopleCountv2)) * 100,
      color: 'red',
    },
    {
      label: 'Không có ý kiến',
      value: `${Number(countOther)}/${Number(totalPeopleCountv2)}`,
      percent: (Number(countOther) / Number(totalPeopleCountv2)) * 100,
      color: 'green',
    },
  ]

  const data2 = [
    {
      label: 'Tán thành',
      value:
        totalPeopleCountv2 === 0
          ? '0%'
          : `${((voteCounts.AGREE / totalPeopleCountv2) * 100).toFixed(2)}%`,
      percent:
        totalPeopleCountv2 === 0
          ? 0
          : (voteCounts.AGREE / totalPeopleCountv2) * 100,
      color: 'blue',
    },
    {
      label: 'Không tán thành',
      value:
        totalPeopleCountv2 === 0
          ? '0%'
          : `${((voteCounts.DISAGREE / totalPeopleCountv2) * 100).toFixed(2)}%`,
      percent:
        totalPeopleCountv2 === 0
          ? 0
          : (voteCounts.DISAGREE / totalPeopleCountv2) * 100,
      color: 'red',
    },
    {
      label: 'Không có ý kiến',
      value:
        totalPeopleCountv2 === 0
          ? '0%'
          : `${((voteCounts.OTHER / totalPeopleCountv2) * 100).toFixed(2)}%`,
      percent:
        totalPeopleCountv2 === 0
          ? 0
          : (voteCounts.OTHER / totalPeopleCountv2) * 100,
      color: 'green',
    },
  ]

  const formatDateTime = dateTimeString => {
    const date = new Date(dateTimeString)

    if (isNaN(date)) {
      return 'Invalid date'
    }

    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')

    return `${day}/${month}/${year} - ${hours}:${minutes}:${seconds}`
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen)
  }

  const handleItemClick = (index, fId) => {
    fetchDetailComment(fId)
    setSelectedIndex(fId)
    setIndexLmao(index)
  }

  function htmlToText(html) {
    const tempElement = document.createElement('div')
    tempElement.innerHTML = html
    return tempElement.textContent || tempElement.innerText || ''
  }

  useEffect(() => {
    if (feedbackDetailData?.feedbackComments?.length === 1) {
      handleItemClick(0, feedbackDetailData?.feedbackComments[0]?.id)
    }
  }, [feedbackDetailData])

  const handleOpenPopupSign = () => {
    signedDocumentStore.setFileBlob(documentAttachment)
    signedDocumentStore.setOriginFileObj({
      name: latestFeedbacks?.fileName,
    })
    setIsVisiblePopupSign(true)
  }

  const feedbackWithCurrentUser = latestFeedbacks?.find(
    item => item?.feedbackUsername === currentUser?.username
  )

  const {
    fileId: fileIdWithCurrentUser,
    fileName: fileNameWithCurrentUser,
    detailFeedbackComment: commentWithCurrentUser,
    voteType: selectedOption,
    id: latestId,
  } = feedbackWithCurrentUser || {}

  const handleAfterSign = async fileSignId => {
    if (!fileSignId) return
    try {
      setIsVisiblePopupSign(false)
      const updateStatusData = {
        feedbackUsername: currentUser?.username,
        detailFeedbackComment: commentWithCurrentUser,
        voteType: selectedOption,
        fileId: fileSignId.fileSignUrl,
        fileName: fileSignId.fileOriginName,
      }
      await FeedbackCommentStore.updateVotingStatus(latestId, updateStatusData)
      await fetchDetailComment(feedbackCommentDataDetailV2.id)
    } catch (error) {
      message.error(error.message)
    } finally {
      setIsVisiblePopupSign(false)
    }
  }

  const currentUserFeedbacks =
    feedbackCommentDataDetailV2?.feedbackCommentDetails?.filter(
      item => item.feedbackUsername === currentUser.username
    ) || []

  const sortedFeedbacks = currentUserFeedbacks.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  )

  const displayComment = sortedFeedbacks.reduce((result, feedback) => {
    if (result) return result
    if (
      feedback.detailFeedbackComment &&
      feedback.detailFeedbackComment !== ''
    ) {
      return feedback.detailFeedbackComment
    }
    return result
  }, '')

  const documentNumberValue =
    feedbackDetailData?.documentNumber || feedbackDetailData?.document_number

  return (
    <>
      <DashboardLayout>
        <Helmet>
          <title>Chi tiết Phiếu lấy ý kiến | {systemName} Portal</title>
        </Helmet>
        <PageTitle
          location={props.location}
          title={feedbackDetailData.title}
          showTitle={true}>
          <HeadingButtonWrapper>
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <span className={'btn-style'}>
                <MoreOutlined style={{ color: blue }} />
              </span>
            </Dropdown>
          </HeadingButtonWrapper>
        </PageTitle>
        <>
          <ViewDetailContent>
            <ContentWrapper>
              <BlockLeft>
                {/* ── Số hồ sơ ── */}
                <ContentBlockWrapper style={{ marginBottom: 16 }}>
                  <div>
                    <span
                      style={{
                        fontWeight: 700,
                        fontSize: 16,
                        color: '#000',
                        whiteSpace: 'nowrap',
                        marginRight: 8,
                      }}>
                      Số hồ sơ:
                    </span>
                    <span
                      style={{ fontSize: 16, fontWeight: 400, color: '#000' }}>
                      {documentNumberValue
                        ? documentNumberValue.includes('/')
                          ? documentNumberValue
                          : `${documentNumberValue}/PLYK-HĐQT`
                        : '-'}
                    </span>
                  </div>
                </ContentBlockWrapper>
                <ContentBlockWrapper style={{ marginBottom: 20 }}>
                  <TitleContentBox>Căn Cứ</TitleContentBox>
                  <div
                    style={{
                      maxWidth: '1200px',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: feedbackDetailData.legalBasis,
                    }}></div>
                </ContentBlockWrapper>
                <ContentBlockWrapper
                  style={{
                    marginBottom: 20,
                  }}>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      fontWeight: 500,
                      fontSize: 14,
                      margin: '-16px -16px 10px -16px',
                      borderTopLeftRadius: 6,
                      borderTopRightRadius: 6,
                      padding: '10px 16px',
                      color: '#fff',
                      backgroundColor: blue,
                    }}
                    onClick={toggleMenu}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <span>Nội dung ý kiến</span>
                      <p style={{ fontSize: 10, margin: 0 }}>
                        (Chọn ý kiến bên dưới để xem chi tiết)
                      </p>
                    </div>
                    <span>{isMenuOpen ? 'Ẩn ý kiến' : 'Hiển thị ý kiến'}</span>
                  </div>

                  <div
                    style={{
                      overflow: 'hidden',
                      maxHeight: isMenuOpen ? '300px' : '0',
                      opacity: isMenuOpen ? 1 : 0,
                      transition:
                        'max-height 0.3s ease, opacity 0.3s ease, padding 0.3s ease',
                      backgroundColor: '#fff',
                    }}>
                    <Menu
                      mode="inline"
                      style={{
                        width: '100%',
                        border: 'none',
                        boxSizing: 'border-box',
                      }}>
                      {feedbackDetailData?.feedbackComments?.map(
                        (feedback, index) => (
                          <Menu.Item
                            key={index}
                            style={{
                              fontSize: '12px',
                              fontWeight: '500',
                              borderRadius: 6,
                              margin: indexLmao === index ? '5px' : 0,
                              backgroundColor:
                                indexLmao === index ? '#E6F4FF' : '#fff',
                              color: indexLmao === index ? '#1677FF' : '#000',
                              padding: '8px 12px',
                              height: 'auto',
                              lineHeight: 'normal',
                            }}
                            onClick={() => handleItemClick(index, feedback.id)}>
                            <Tooltip
                              title={htmlToText(feedback.content)}
                              placement="top"
                              overlayStyle={{
                                maxWidth: '300px',
                                whiteSpace: 'normal',
                              }}>
                              <div
                                style={{
                                  width: '100%',
                                  display: 'block',
                                  whiteSpace:
                                    indexLmao === index ? 'normal' : 'nowrap',
                                  textOverflow:
                                    indexLmao === index ? 'unset' : 'ellipsis',
                                  overflow: 'hidden',
                                  lineHeight: '1.5',
                                  wordBreak: 'break-word',
                                  maxHeight:
                                    indexLmao === index ? 'none' : '1.5em',
                                }}>
                                <span
                                  style={{
                                    marginRight: '10px',
                                    fontWeight: 700,
                                  }}>
                                  {index + 1}.
                                </span>
                                <span style={{ fontWeight: 700 }}>
                                  {htmlToText(feedback.content)}
                                </span>
                              </div>
                            </Tooltip>
                          </Menu.Item>
                        )
                      )}
                    </Menu>
                  </div>
                </ContentBlockWrapper>


                <FeedbackCommentSection
                  feedbackCommentDataDetailV2={feedbackCommentDataDetailV2}
                  getNameUppercaseByUsername={getNameUppercaseByUsername}
                  selectedIndex={selectedIndex}
                />

                <ContentBlockWrapper
                  style={{
                    marginBottom: 20,
                  }}>
                  <TitleContentBox>Tài liệu kèm theo</TitleContentBox>
                  <div
                    style={{
                      maxWidth: '1200px',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: feedbackDetailData.attachedDocuments,
                    }}></div>
                </ContentBlockWrapper>
                <ContentBlockWrapper style={{ marginBottom: 20 }}>
                  <TitleContentBox>Nội dung khác</TitleContentBox>
                  <div
                    style={{
                      maxWidth: '1200px',
                      whiteSpace: 'pre-wrap',
                      overflowWrap: 'break-word',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: feedbackDetailData.otherContent,
                    }}></div>
                </ContentBlockWrapper>
              </BlockLeft>
              <BlockRight>
                {!selectedIndex &&
                  feedbackDetailData?.feedbackComments?.map(
                    (feedback, index) => (
                      <ContentBlockWrapper
                        key={feedback.id}
                        style={{ marginBottom: 20 }}>
                        <TitleContentBox>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}>
                            <Tooltip
                              title={`Thống kê - ${htmlToText(
                                feedback.content
                              )}`}
                              placement="top"
                              overlayStyle={{
                                maxWidth: '300px',
                                whiteSpace: 'normal',
                              }}>
                              <span>
                                Thống kê -{' '}
                                {feedback.content
                                  .replace(/<[^>]+>/g, '')
                                  .substring(0, 50) +
                                  (feedback.content.replace(/<[^>]+>/g, '')
                                    .length > 50
                                    ? '...'
                                    : '')}
                              </span>
                            </Tooltip>
                          </div>
                        </TitleContentBox>
                        <List
                          itemLayout="horizontal"
                          dataSource={getDataForFeedback(feedback.id)}
                          renderItem={item => (
                            <List.Item>
                              <Row style={{ width: '100%' }}>
                                <Col span={12}>
                                  <span>{item.label}</span>
                                </Col>
                                <Col span={12} style={{ textAlign: 'right' }}>
                                  <span>{item.value}</span>
                                </Col>
                                <Col span={24}>
                                  <Progress
                                    percent={item.percent}
                                    strokeColor={item.color}
                                    status="active"
                                    showInfo={false}
                                  />
                                </Col>
                              </Row>
                            </List.Item>
                          )}
                        />
                      </ContentBlockWrapper>
                    )
                  )}
                {selectedIndex && idIncludes?.includes(selectedIndex) && (
                  <ContentBlockWrapper
                    key={selectedIndex}
                    style={{ marginBottom: 20 }}>
                    <TitleContentBox>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}>
                        <span>Thống kê</span>
                        <div style={{ gap: 10, display: 'flex' }}>
                          <Tag
                            onClick={() => {
                              setSelectedIndex(null)
                              setIndexLmao(null)
                            }}
                            style={{
                              borderRadius: 10,
                              cursor: 'pointer',
                              marginRight: 0,
                              width: 'auto',
                              textAlign: 'center',
                            }}
                            color={'blue'}>
                            Tổng hợp biểu quyết
                          </Tag>
                        </div>
                      </div>
                    </TitleContentBox>
                    <List
                      itemLayout="horizontal"
                      dataSource={getDataForFeedback(selectedIndex)}
                      renderItem={item => {
                        return (
                          <List.Item>
                            <Row style={{ width: '100%' }}>
                              <Col span={12}>
                                <span>{item.label}</span>
                              </Col>
                              <Col span={12} style={{ textAlign: 'right' }}>
                                <span>{item.countValue}</span>
                              </Col>
                              <Col span={24}>
                                <Progress
                                  percent={item.percent}
                                  strokeColor={item.color}
                                  status="active"
                                  showInfo={false}
                                  strokeWidth={10}
                                />
                              </Col>
                            </Row>
                          </List.Item>
                        )
                      }}
                    />
                  </ContentBlockWrapper>
                )}
                {idIncludes?.includes(selectedIndex) && (
                  <>
                    {userNameHaventVoting.includes(currentUser?.username) && (
                      <ContentBlockWrapper style={{ marginBottom: 20 }}>
                        <TitleContentBox>
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              alignItems: 'center',
                            }}>
                            <span>Ý kiến bạn biểu quyết</span>
                            <div style={{ gap: 10, display: 'flex' }}>
                              <AccessControlAction
                                aclActionType={ACL_ACTION_TYPE.voting__HDQT}>
                                <Tag
                                  onClick={() => {
                                    setIsVisiblePopupBieuQuyet(true)
                                  }}
                                  style={{
                                    borderRadius: 10,
                                    cursor: 'pointer',
                                    marginRight: 0,
                                    width: '80px',
                                    textAlign: 'center',
                                  }}
                                  color={'blue'}>
                                  Biểu Quyết
                                </Tag>
                              </AccessControlAction>
                              <Tag
                                onClick={handleOpenPopupSign}
                                style={{
                                  borderRadius: 10,
                                  cursor: 'pointer',
                                  marginRight: 0,
                                  width: '80px',
                                  textAlign: 'center',
                                }}
                                color={'blue'}>
                                Ký số
                              </Tag>
                            </div>
                          </div>
                        </TitleContentBox>
                        <DocumentInfoList>
                          {latestFeedbacks?.filter(
                            item =>
                              item.feedbackUsername === currentUser.username
                          )[0]?.createdAt ? (
                            <>
                              <dt>Bạn Biểu quyết</dt>
                              <dd>
                                Ngày:{' '}
                                {formatDateTime(
                                  latestFeedbacks?.filter(
                                    item =>
                                      item.feedbackUsername ===
                                      currentUser.username
                                  )[0].createdAt
                                )}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Bạn Biểu quyết</dt>
                              <dd>Chưa có ngày biểu quyết</dd>
                            </>
                          )}
                          {latestFeedbacks?.filter(
                            item =>
                              item.feedbackUsername === currentUser.username
                          )[0]?.updatedAt ? (
                            <>
                              <dt>Thay đổi</dt>
                              <dd>
                                Ngày:{' '}
                                {formatDateTime(
                                  latestFeedbacks?.filter(
                                    item =>
                                      item.feedbackUsername ===
                                      currentUser.username
                                  )[0]?.updatedAt
                                )}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Thay đổi</dt>
                              <dd>Chưa có ngày thay đổi</dd>
                            </>
                          )}
                          {latestFeedbacks?.filter(
                            item =>
                              item.feedbackUsername === currentUser.username
                          )[0]?.voteType ? (
                            <>
                              <dt>Lựa chọn</dt>
                              <dd>
                                {latestFeedbacks?.filter(
                                  item =>
                                    item.feedbackUsername ===
                                    currentUser.username
                                )[0]?.voteType === 'AGREE'
                                  ? 'Tán thành'
                                  : latestFeedbacks?.filter(
                                      item =>
                                        item.feedbackUsername ===
                                        currentUser.username
                                    )[0]?.voteType === 'DISAGREE'
                                  ? 'Không tán thành'
                                  : 'Không có ý kiến'}
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Lựa chọn</dt>
                              <dd>Chưa có lựa chọn</dd>
                            </>
                          )}
                          {/* {displayComment ? (
                            <>
                              <dt>Các ý kiến bổ sung</dt>
                              <dd>
                                <div
                                  style={{
                                    maxWidth: '318px',
                                    whiteSpace: 'pre-wrap',
                                    overflowWrap: 'break-word',
                                    wordBreak: 'keep-all',
                                    lineBreak: 'strict',
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: displayComment,
                                  }}
                                />
                              </dd>
                            </>
                          ) : (
                            <>
                              <dt>Các ý kiến bổ sung</dt>
                              <dd>Không có ý kiến</dd>
                            </>
                          )} */}
                        </DocumentInfoList>
                      </ContentBlockWrapper>
                    )}
                    {!userNameHaventVoting.includes(currentUser?.username) && (
                      <div
                        style={{
                          fontWeight: 500,
                          fontSize: '14px',
                          margin: '-16px -16 10px',
                          borderTopLeftRadius: 6,
                          borderTopRightRadius: 6,
                          padding: '10px 16px',
                          color: '#fff',
                          backgroundColor: blue,
                          marginBottom: 20,
                        }}>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <span>Đăng ý kiến</span>
                          <Tag
                            onClick={() => {
                              setIsVisiblePopupBieuQuyet(true)
                            }}
                            style={{
                              borderRadius: 10,
                              cursor: 'pointer',
                              marginRight: 0,
                              width: '80px',
                              textAlign: 'center',
                            }}
                            color={'blue'}>
                            Đăng ý kiến
                          </Tag>
                        </div>
                      </div>
                    )}
                    <ContentBlockWrapper style={{ marginBottom: 20 }}>
                      <TitleContentBox>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <span>Ý kiến biểu quyết (Ký số)</span>
                        </div>
                      </TitleContentBox>
                      <DocumentInfoList>
                        {latestFeedbacks?.length > 0 ? (
                          latestFeedbacks.some(
                            comment => !utils.isNullish(comment.voteType)
                          ) ? (
                            latestFeedbacks
                              .filter(
                                comment => !utils.isNullish(comment.voteType)
                              )
                              .map(comment => (
                                <Fragment key={comment.fileId}>
                                  <dt>
                                    {getNameUppercaseByUsername(
                                      comment.feedbackUsername
                                    )}
                                  </dt>
                                  <dd>
                                    <FileItem
                                      key={comment.fileId}
                                      file_id={comment.fileId}
                                      file_name={comment.fileName}
                                      file_type={utils.getExtensionFile(
                                        comment.fileName
                                      )}
                                    />
                                  </dd>
                                </Fragment>
                              ))
                          ) : (
                            <Fragment key={new Date().getTime()}>
                              <dt>Biểu quyết</dt>
                              <dd>Chưa có biểu quyết</dd>
                            </Fragment>
                          )
                        ) : (
                          <Fragment key={new Date().getTime() + 1}>
                            <dt>Biểu quyết</dt>
                            <dd>Chưa có biểu quyết</dd>
                          </Fragment>
                        )}
                      </DocumentInfoList>
                    </ContentBlockWrapper>
                    <ContentBlockWrapper style={{ marginBottom: 20 }}>
                      <TitleContentBox>Tài liệu kèm theo</TitleContentBox>
                      <DocumentInfoList>
                        {allFileNames?.length > 0 ? (
                          <>
                            <dt>Tài liệu đính kèm</dt>
                            <dd>
                              {allFileNames?.flatMap(group =>
                                group.map(fileName => (
                                  <FileItem
                                    style={{ marginBottom: '8px' }}
                                    key={fileName.id}
                                    file_id={fileName.fileId}
                                    file_name={fileName.fileName}
                                    file_type={utils.getExtensionFile(
                                      fileName.fileName
                                    )}
                                  />
                                ))
                              )}
                            </dd>
                          </>
                        ) : (
                          <>
                            <dt>Tài liệu đính kèm</dt>
                            <dd>Chưa có tài liệu đính kèm</dd>
                          </>
                        )}
                      </DocumentInfoList>
                    </ContentBlockWrapper>
                    <ContentBlockWrapper>
                      <TitleContentBox>
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                          }}>
                          <span>Xử lý phiếu</span>
                        </div>
                      </TitleContentBox>
                      <DocumentInfoList>
                        <UserListWrapper
                          style={{ display: 'flex', flexGrow: 1, margin: 0 }}>
                          <dt>Người xử lý</dt>
                          <dd style={{ margin: 0, flex: 1 }}>
                            {handlerAssignList?.length !== 0 ? (
                              <PopoverWatchTime
                                departWithUsers={departmentWithUserListV2}
                                userList={selectUserStore.convertListToDefault(
                                  handlerAssignListWithNames?.filter(user => {
                                    return (
                                      user.permission ===
                                        ASSIGNEE_TYPE.HANDLER &&
                                      user.name_uppercase != null
                                    )
                                  })
                                )}
                                title={'Người xử lý'}
                                isFullViewer={true}
                                compared_date={
                                  VIEWLOG_DATE.internal_document_until
                                }
                                typeId={feedbackId}
                                created_at={feedbackDetailData.createdAt}
                              />
                            ) : (
                              <EmptyText>Không có Người xử lý.</EmptyText>
                            )}
                          </dd>
                        </UserListWrapper>
                        <UserListWrapper
                          style={{ display: 'flex', flexGrow: 1, margin: 0 }}>
                          <dt>Người theo dõi</dt>
                          <dd style={{ margin: 0, flex: 1 }}>
                            {combinerAssignList?.length !== 0 ? (
                              <PopoverWatchTime
                                departWithUsers={departmentWithUserListV2}
                                userList={selectUserStore.convertListToDefault(
                                  combinerAssignListWithNames?.filter(user => {
                                    return (
                                      user.permission ===
                                        ASSIGNEE_TYPE.FOLLOWER &&
                                      user.name_uppercase != null
                                    )
                                  })
                                )}
                                title={'Danh sách Ý kiến của các tiểu ban'}
                                isFullViewer={true}
                                compared_date={
                                  VIEWLOG_DATE.internal_document_until
                                }
                                typeId={feedbackId}
                                created_at={feedbackDetailData.createdAt}
                              />
                            ) : (
                              <EmptyText>Không có Ban KS/Ban KTNB.</EmptyText>
                            )}
                          </dd>
                        </UserListWrapper>
                      </DocumentInfoList>
                    </ContentBlockWrapper>
                  </>
                )}
              </BlockRight>
            </ContentWrapper>
          </ViewDetailContent>
        </>
      </DashboardLayout>

      {isEditModalVisible && (
        <FeedbackBoardUpdate
          feedbackDetailData={feedbackDetailData}
          isVisible={isEditModalVisible}
          handleCancel={handleCloseEditModal}
          fetchFeedback={fetchFeedbackDetailData}
          setIsVisible={setIsEditModalVisible}
          finalUserList={userList}
          assignees={feedbackDetailData.assignees}
        />
      )}
      {isVisiblePopupBieuQuyet && (
        <FeedbackVotingPopup
          visible={isVisiblePopupBieuQuyet}
          onClose={handleClosePopup}
          feedbackDetailData={feedbackDetailData}
          fetchFeedbackDetailData={fetchFeedbackDetailData}
          fetchDetailComment={fetchDetailComment}
          selectedIndex={selectedIndex}
          votingCommentId={selectedIndex}
          userList={userList}
          userNameHaventVoting={userNameHaventVoting}
        />
      )}
      {exportDocx && (
        <ExportDocx
          countAllUser={countAllUser}
          countAgree={countAgree}
          countDisAgree={countDisAgree}
          countOther={countOther}
          totalPeopleCount={totalPeopleCountv2}
          feedbackDetailData={feedbackDetailData}
          finalUserList={userList}
          resultsVoting={results}
        />
      )}

      {isVisiblePopupSign && (
        <FeedbackSign
          isVisiblePopupSign={isVisiblePopupSign}
          handleClosePopupSign={() => {
            setIsVisiblePopupSign(false)
          }}
          hiddenSelectDocument
          fileId={fileIdWithCurrentUser}
          fileName={fileNameWithCurrentUser}
          handleAfterSign={handleAfterSign}
        />
      )}
    </>
  )
}

export default inject(
  'selectUserStore',
  'documentAccessibilityStore',
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'FeedbackProcedureStore',
  'FeedbackCommentStore',
  'departmentStore',
  'userStore',
  'selectUserStore',
  'electronicDocumentStore',
  'signedDocumentStore',
  'fileStore',
  'userGroupStore'
)(observer(FeedbackBoardDetail))
